import { useChatUpdated, useChatCreated } from "src/hooks"

export default function SignalRListener({ setChatUpdates }) {
    
    useChatCreated();

    useChatUpdated((update) => {
        setChatUpdates(prev => ({
            ...prev,
            [update.chatId]: { ...prev[update.chatId], ...update }
        }));
    });

    return null;
}
